<template>
  <div class="light-box" @click="closeLightbox()" :class="{'active':isActive}">
    <div v-if="selectedLightBox!==null" class="image-container">
      <img :src="selectedLightBox">
    </div>
  </div>
</template>

<script>
export default {
  name: "lightbox",
  components: {
    //ProjectNav
  },
  props: ["selectedLightBox"],

  mounted() {},
  methods: {
    animateInImage() {
      this.checkTimer();
      const self = this;
      this.timer = setTimeout(() => {
        self.isActive = true;
        clearTimeout(this.timer);
      }, 1);
    },
    closeLightbox() {
      const self = this;
      this.checkTimer();

      this.isActive = false;
      this.timer = setTimeout(() => {
        self.$parent.selectedLightBox = null;
        clearTimeout(this.timer);
      }, 10);
    },
    checkTimer() {
      if (this.timer === null) {
        clearTimeout(this.timer);
      }
    },
  },
  data() {
    return {
      isActive: false,
      timer: null,
    };
  },
  watch: {
    selectedLightBox: {
      handler(newValue, oldValue) {
        if (newValue && newValue !== null) {
          this.animateInImage();
        }
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.light-box {
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
  transition: all 0.5s ease-in-out;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: -99;
  opacity: 0;
  align-items: center;
  justify-content: center;
}

.image-container {
  max-width: 1600px;
  display: block;
  transition: all 1s ease-in-out;
  animation-delay: 1s;
}
.image-container img {
  border: 10px white solid;
  box-sizing: border-box;
}

.active.light-box {
  opacity: 1;
  z-index: 9999;
}
</style>
